import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Layout from '@/layouts/Layout';
import Home from '@/pages/Home';
import LiveNow from '@/pages/LiveNow';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ForgotPassword from '@/pages/ForgotPassword';
import NotFound from '@/pages/NotFound';
import SearchList from '@/pages/SearchList';
import PrivacyData from '@/pages/PrivacyData';
import ServiceSearchList from '@/pages/ServiceSearchList';

import AboutUs from '@/pages/AboutUs';
import ProductDetail from '@/pages/ProductDetail';
import ServiceProductDetail from '@/pages/ServiceProductDetail';
import ServiceDetail from '@/pages/ServiceDetail';
import StoreDetail from '@/pages/StoreDetail';


import PlaceOrder from '@/pages/PlaceOrder';
import EmergencyServicePlaceOrder from '@/pages/EmergencyServicePlaceOrder';
import ServicePlaceOrder from '@/pages/ServicePlaceOrder';

import PaymentSuccessful from '@/pages/PaymentSuccessful';
import OrderDetail from '@/pages/OrderDetail';
import StoreEntry from '@/pages/StoreEntry';
import StorePublishProduct from '@/pages/StorePublishProduct';
import StorePublishProductEdit from '@/pages/StorePublishProduct/edit';
import StorePublishProductShowcase from '@/pages/StorePublishProduct/showcase';


import ChatList from '@/pages/ChatList';
import YourTownloop from '@/pages/YourTownloop';

import Cart from '@/pages/YourTownloop/Subroute/Cart/Cart';

import YourTownloopHome from '@/pages/YourTownloop/Subroute/YourTownloopHome/YourTownloopHome';

import YourFavorites from '@/pages/YourTownloop/Subroute/YourFavorites/YourFavorites';

import YourOrders from '@/pages/YourTownloop/Subroute/YourOrders/YourOrders';

import PostOrders from '@/pages/YourTownloop/Subroute/PostOrders/PostOrders';

import ServiceOrders from '@/pages/YourTownloop/Subroute/ServiceOrders/ServiceOrders';

import FollowedStores from '@/pages/YourTownloop/Subroute/FollowedStores/FollowedStores';

import YourPaymentMethods from '@/pages/YourTownloop/Subroute/YourPaymentMethods/YourPaymentMethods';


import RefundsSupport from '@/pages/YourTownloop/Subroute/RefundsSupport/RefundsSupport';

import BrowsingHistory from '@/pages/YourTownloop/Subroute/BrowsingHistory/BrowsingHistory';

import AccountSecurity from '@/pages/YourTownloop/Subroute/AccountSecurity/AccountSecurity';


import YourProfile from '@/pages/YourTownloop/Subroute/YourProfile/YourProfile';

import Addresses from '@/pages/YourTownloop/Subroute/Addresses/Addresses';
import EngineerZone from '@/pages/YourTownloop/Subroute/EngineerZone/EngineerZone';

import YourStore from '@/pages/YourTownloop/Subroute/YourStore/YourStore';

import GoLiveNow from '@/pages/YourTownloop/Subroute/GoLiveNow/GoLiveNow';
import LiveList from '@/pages/YourTownloop/Subroute/LiveList/index';
import CreateLive from '@/pages/YourTownloop/Subroute/CreateLive/index';
import GoLiveNowVideo from '@/pages/YourTownloop/Subroute/GoLiveNowVideo/GoLiveNowVideo';
import LiveEnded from '@/pages/YourTownloop/Subroute/LiveEnded/LiveEnded';
import LiveStreamingProduct from '@/pages/YourTownloop/Subroute/LiveStreamingProduct/LiveStreamingProduct';
import Privacy from '@/pages/privacy';

import YourProducts from '@/pages/YourTownloop/Subroute/YourProducts/YourProducts';

import StoreOrders from '@/pages/YourTownloop/Subroute/StoreOrders/StoreOrders';
import StoreInformation from '@/pages/YourTownloop/Subroute/StoreInformation/StoreInformation';
import ServiceCategory from '@/pages/YourTownloop/Subroute/ServiceCategory';

import EmergencyService from '@/pages/EmergencyService';

import CarpoolService from '@/pages/CarpoolService';

import CarpoolServiceDetail from '@/pages/CarpoolServiceDetail';

import MembershipService from '@/pages/MembershipService';

import OBSStudioUserGuide from '@/pages/OBSStudioUserGuide';

import Download from '@/pages/download';

import WebinarModal from '@/pages/WebinarModal';
import PrivacyPolicy from '@/pages/PrivacyPolicy';

const router = createBrowserRouter([
  // {
  //   path: '/login',
  //   element: <Login />,
  // },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: 'serviceCategory',
        element: <ServiceCategory />,
      },
      {
        index: true,
        element: <Home />,
      },

      {
        path: 'privacy',
        element: <Privacy />,
      },
      {
        path: 'privacyPolicy',
        element: <PrivacyPolicy />,
      },
      {
        path: 'liveNow',
        element: <LiveNow />,
      },

      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/register',
        element: <Register />,
      },
      {
        path: '/forgotpassword',
        element: <ForgotPassword />,
      },
      {
        path: 'searchList',
        element: <SearchList />,
      },
      {
        path: 'privacy_data',
        element: <PrivacyData />,
      },
      {
        path: 'serviceSearchList',
        element: <ServiceSearchList />,
      },
      {
        path: 'aboutUs',
        element: <AboutUs />,
      },
      {
        path: 'webinarModal',
        element: <WebinarModal />,
      },
      {
        path: 'ProductDetail/:id',
        element: <ProductDetail />,
      },
      {
        path: 'ServiceProductDetail/:id',
        element: <ServiceProductDetail />,  
      },
      {
        path: 'EmergencyServiceDetail/:id',
        element: <ServiceDetail />,
      },
      {
        path: 'StoreDetail/:id',
        element: <StoreDetail />,
      },
      {
        path: 'yourProducts/:id',
        element: <YourProducts />,
      },
      {
        path: 'PlaceOrder',
        element: <PlaceOrder />,
      },
      {
        path: 'emergency_service_ordering',
        element: <EmergencyServicePlaceOrder />,
      },
      {
        path: 'ServicePlaceOrder',
        element: <ServicePlaceOrder />,
      },
      {
        path: 'membershipService',
        element: <MembershipService />,
      },
      {
        path: 'payment_success',
        element: <PaymentSuccessful />,
      },
      {
        path: 'OrderDetail/:id',
        element: <OrderDetail />,
      },
      {
        path: 'emergencyService',
        element: <EmergencyService />,
      },
      {
        path: 'carpoolService',
        element: <CarpoolService />,
      },
      {
        path: 'CarpoolServiceDetail/:id',
        element: <CarpoolServiceDetail />,
      },
      {
        path: 'chatList',
        element: <ChatList />,
      },
      {
        path: 'StoreEntry',
        element: <StoreEntry />,
      },
      {
        path: 'StorePublishProduct',
        element: <StorePublishProduct />,
      },
      {
        path: 'StorePublishProductEdit',
        element: <StorePublishProductEdit />,
      },
      {
        path: 'StorePublishProductShowcase',
        element: <StorePublishProductShowcase />,
      },
      {
        path: 'yourtownloop',
        element: <YourTownloop />,
        children: [
          {
            index: true,
            element: <YourTownloopHome />,
          },
          {
            path: 'cart',
            element: <Cart />,
          },
          {
            path: 'orders',
            element: <YourOrders />,
          },
          {
            path: 'postorders',
            element: <PostOrders />,
          },
          {
            path: 'serviceorders',
            element: <ServiceOrders />,
          },
          {
            path: 'favorites',
            element: <YourFavorites />,
          },
          {
            path: 'followedStores',
            element: <FollowedStores />,
          },
          {
            path: 'yourPaymentMethods',
            element: <YourPaymentMethods />,
          },
          {
            path: 'refundsSupport',
            element: <RefundsSupport />,
          },
          {
            path: 'browsingHistory',
            element: <BrowsingHistory />,
          },
          {
            path: 'accountSecurity',
            element: <AccountSecurity />,
          },
          {
            path: 'yourProfile',
            element: <YourProfile />,
          },
          {
            path: 'addresses',
            element: <Addresses />,
          },
          {
            path: 'engineer_zone',
            element: <EngineerZone />,
          },
          
          {
            path: 'yourStore',
            element: <YourStore />,
          },
          {
            path: 'goLiveNow',
            element: <GoLiveNow />,
          },
          {
            path: 'liveList',   // 直播列表
            element: <LiveList />,
          },
          {
            path: 'createLiveStream',   // 直播创建
            element: <CreateLive />,
          },
          {
            path: 'liveStreamingProduct',
            element: <LiveStreamingProduct />,
          },
        
          {
            path: 'yourProducts',
            element: <YourProducts />,
          },
          {
            path: 'storeInformation',
            element: <StoreInformation />,
          },
          {
            path: 'storeOrders',
            element: <StoreOrders />,
          },
          {
            path: 'serviceCategory',
            element: <ServiceCategory />,
          },
        ],
      },
      {
        path: 'goLiveNowVideo',
        element: <GoLiveNowVideo />,  
      },
      {
        path: 'liveEnded',
        element: <LiveEnded />,
      },
      {
        path: 'OBSStudioUserGuide',
        element: <OBSStudioUserGuide />,  
      },
      {
        path: 'download',
        element: <Download />,  
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  }
]);

export default router; 